import { useSuspenseQuery } from "@tanstack/react-query";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { Users } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";
import { orpc } from "@/orpc/client";
import { PartnerCreateFormDialog } from "@/pages/partners/components/PartnerCreateFormDialog";
import { Partners } from "@/pages/partners/Partners";
import { PartnersLayout } from "@/pages/partners/PartnersLayout";

export function PartnersPage() {
	const navigate = useNavigate();
	const { create: isCreateModalOpen } = useSearch({ from: "/_app/partners/" });

	const { data: partners } = useSuspenseQuery(
		orpc.partners.list.queryOptions({ input: {} }),
	);

	const openCreateModal = () => {
		navigate({
			to: "/partners",
			search: (search) => ({ ...search, create: true }),
		});
	};

	return (
		<>
			<PartnersLayout
				onCreateClick={openCreateModal}
				isEmpty={partners.length === 0}
				emptyState={
					<EmptyState
						icon={Users}
						title="No partners found"
						subtitle="Create a partner to start tracking referral attributions."
					/>
				}
			>
				<Partners />
			</PartnersLayout>
			<PartnerCreateFormDialog
				isOpen={!!isCreateModalOpen}
				onClose={() => navigate({ to: "/partners" })}
			/>
		</>
	);
}
